import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import { xcss } from '@atlaskit/primitives/xcss';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import Flex from '@atlaskit/primitives/components/flex';

import type { RendererContentStatePlaceholderProps } from './types.ts';

const loadingPlaceholderStyles = xcss({
	cursor: 'pointer',
	minHeight: '32px',
	borderRadius: 'radius.small',
	paddingRight: 'space.100',
	backgroundColor: 'utility.elevation.surface.current',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentStateNamePlaceholderWrapper = styled.div({
	fontWeight: token('font.weight.medium'),
	visibility: 'hidden',
});

const contentStateColorPlaceholderStyles = xcss({
	borderRadius: 'radius.full',
	height: '10px',
	width: '10px',
	marginLeft: 'space.050',
	marginRight: 'space.075',
	backgroundColor: 'color.background.neutral',
});

const flexWrapperStyles = xcss({
	marginLeft: 'space.075',
	marginRight: 'space.075',
});

export const RendererContentStatePlaceholder = ({
	contentState,
}: RendererContentStatePlaceholderProps): React.JSX.Element => {
	return (
		<Flex xcss={flexWrapperStyles}>
			<Flex
				alignItems="center"
				xcss={loadingPlaceholderStyles}
				testId="subtle-renderer-content-state-placeholder"
			>
				<Box
					xcss={contentStateColorPlaceholderStyles}
					testId="subtle-renderer-content-state-color-placeholder"
				/>
				<ContentStateNamePlaceholderWrapper>
					{contentState?.name}
				</ContentStateNamePlaceholderWrapper>
			</Flex>
		</Flex>
	);
};
